import s from "./SurveysActionsComponent.module.css";
import React from "react";
import { Input, Radio, Select, Space } from "antd";
import {
    SortAscendingOutlined,
    SortDescendingOutlined,
} from "@ant-design/icons";

export const SurveysActionsComponent = ({
    searchQuery,
    setSearchQuery,
    sortBy,
    setSortBy,
    handleWorkSpaceChange,
    currentWorkspace,
}) => {
    const handleChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleSortingChange = (e) => {
        setSortBy(e.target.value);
    };

    const selectOptions = [
        { label: "All", value: "all" },
        { label: "Public", value: "public" },
        { label: "Private", value: "private" },
    ];

    return (
        <div className={s.container}>
            <h1 className="projects-heading-title">Surveys</h1>
            <Select
                value={currentWorkspace}
                showSearch
                onChange={(e) => handleWorkSpaceChange(e)}
                options={selectOptions}
                filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            />
            <Input
                value={searchQuery}
                placeholder="Find surveys"
                onChange={handleChange}
                allowClear
            />

            <div>
                <Space align="center">
                    Sort By:
                    <Radio.Group onChange={handleSortingChange} value={sortBy}>
                        <Radio value={"createdAt"}>Date Oldest</Radio>
                        <Radio value={"createdAt desc"}>Date Newest</Radio>
                        <Radio value={"name"}>
                            Name <SortAscendingOutlined />
                        </Radio>
                        <Radio value={"name desc"}>
                            Name <SortDescendingOutlined />
                        </Radio>
                    </Radio.Group>
                </Space>
            </div>
        </div>
    );
};
